import AppSettings from '../../app/AppSettings';
import { ShoppingContext, StoreContext } from '../../app/data/model';
import { LanguageCode } from '../../app/localization/LanguageCode';
import RouteDefinitions from '../../app/RouteDefinitions';
import { BaseShareConfiguratorUrlProvider } from '../../app/shared/BaseShareConfiguratorUrlProvider';
import { getB2cOrigin } from '../../app/shared/getB2cOrigin';
import { StoreUrlBuilder } from '../../app/shared/StoreUrlBuilder';

export class B2bShareConfiguratorUrlProvider extends BaseShareConfiguratorUrlProvider {
  private storeId?: string;
  private languageCode?: string;

  constructor(settings: AppSettings) {
    super(settings);
  }

  initialize(shoppingContext: ShoppingContext, storeContext: StoreContext): void {
    const store = storeContext.store.origin ?? storeContext.store;
    this.storeId = store.id;
    this.languageCode = LanguageCode.isAnyOf(shoppingContext.languageCode, store.languages)
      ? shoppingContext.languageCode
      : 'en-GB';
  }

  public getUrl(code: string, quantity: number = 1): string {
    if (!this.storeId || !this.languageCode) {
      throw new Error(`This instance of share link provider is not initialized`);
    }

    const b2cOrigin = getB2cOrigin(this.settings.baseUrl);
    const query = this.getQuantityQuery(quantity);
    const relativeUrl = StoreUrlBuilder.build(
      this.storeId,
      this.languageCode,
      RouteDefinitions.getUrlTo((x) => x.codeRoute, { code: code }),
      query,
    ).toString();

    return `${b2cOrigin}${relativeUrl}`;
  }
}
